import { useEffect, useRef } from "react";

/**
 * Run an effect exactly once on mount, with cleanup on unmount. Use this for
 * true mount-time external system sync (DOM integration, browser API
 * subscriptions, third-party widgets). Components must not call `useEffect`
 * directly; reusable custom hooks may.
 */
export function useMountEffect(effect: () => void | (() => void)): void {
	const effectRef = useRef(effect);
	effectRef.current = effect;
	useEffect(() => {
		return effectRef.current();
	}, []);
}
